/**
* @license Apache-2.0
*
* Copyright (c) 2026 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-read-only-property';


// MAIN //

/**
* Namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name dchebyshev
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/strided/distances/dchebyshev}
*/
import dchebyshev from './../../../strided/distances/dchebyshev';
setReadOnly( ns, 'dchebyshev', dchebyshev );

/**
* @name dcityblock
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/strided/distances/dcityblock}
*/
import dcityblock from './../../../strided/distances/dcityblock';
setReadOnly( ns, 'dcityblock', dcityblock );

/**
* @name dcorrelation
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/strided/distances/dcorrelation}
*/
import dcorrelation from './../../../strided/distances/dcorrelation';
setReadOnly( ns, 'dcorrelation', dcorrelation );

/**
* @name dcosineDistance
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/strided/distances/dcosine-distance}
*/
import dcosineDistance from './../../../strided/distances/dcosine-distance';
setReadOnly( ns, 'dcosineDistance', dcosineDistance );

/**
* @name dcosineSimilarity
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/strided/distances/dcosine-similarity}
*/
import dcosineSimilarity from './../../../strided/distances/dcosine-similarity';
setReadOnly( ns, 'dcosineSimilarity', dcosineSimilarity );

/**
* @name deuclidean
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/strided/distances/deuclidean}
*/
import deuclidean from './../../../strided/distances/deuclidean';
setReadOnly( ns, 'deuclidean', deuclidean );

/**
* @name dminkowski
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/strided/distances/dminkowski}
*/
import dminkowski from './../../../strided/distances/dminkowski';
setReadOnly( ns, 'dminkowski', dminkowski );

/**
* @name dsquaredEuclidean
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/strided/distances/dsquared-euclidean}
*/
import dsquaredEuclidean from './../../../strided/distances/dsquared-euclidean';
setReadOnly( ns, 'dsquaredEuclidean', dsquaredEuclidean );


// EXPORTS //

export default ns;
